import { Briefcase, RefreshCw, Clock, CalendarDays } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { WAYS } from "@/data/content";

const ICONS = { Briefcase, RefreshCw, Clock, CalendarDays };

const WaysSection = () => (
  <section id="ways" data-testid="ways-section" className="relative py-16 sm:py-24 bg-[#FAF5EC]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal><Eyebrow>Engagement models</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight text-kiki-ink mt-3 mb-8 leading-[1.05]">
          Ways to work with us
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WAYS.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <Reveal key={w.name} delay={i * 0.07} className="h-full">
              <div
                data-testid={`way-card-${i}`}
                className="h-full rounded-2xl border border-kiki-line bg-white p-6 hover:border-kiki-gold/40 transition-colors duration-300"
              >
                <span className="w-12 h-12 rounded-full bg-kiki-surface flex items-center justify-center text-kiki-gold">
                  <Icon className="w-5 h-5" />
                </span>
                <h3 className="font-display text-xl font-medium text-kiki-ink mt-4">{w.name}</h3>
                <p className="text-sm text-kiki-muted font-light mt-1">{w.line}</p>
                {w.price && <p className="text-sm text-kiki-gold font-outfit font-semibold mt-2">{w.price}</p>}
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.3}>
        <p data-testid="pricing-disclaimer" className="mt-6 text-sm text-kiki-muted font-light italic">
          All pricing is indicative and varies with scope, volume and complexity.
        </p>
      </Reveal>
    </div>
  </section>
);

export default WaysSection;
